import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_HUMAN_VERIFICATION = defineFcm('enable_human_verification')
	.asBoolean()
	.withDefault(false)
	.toConfig();
